export interface Category {
  slug: string;
  name: string;
  description: string;
}

export const CATEGORIES: Category[] = [
  { slug: "beverages", name: "BEVERAGES", description: "Chilled, brewed & bottled drinks" },
  { slug: "bispc", name: "BIS&P.C", description: "Biscuits & personal care essentials" },
  { slug: "choco-bars", name: "CHOCO.&BARS", description: "Chocolate bars & candy" },
  { slug: "cooking-oils", name: "Cooking Oils", description: "Oils, ghee & cooking fats" },
  { slug: "food", name: "FOOD", description: "Everyday food staples" },
  { slug: "home-care", name: "HOME CARE", description: "Cleaning & household care" },
  { slug: "indian-groceries", name: "Indian Groceries", description: "Spices, lentils & pantry staples" },
  { slug: "jams-spreads", name: "Jams & Spreads", description: "Jams, honey & spreads" },
  { slug: "perfumes", name: "PERFUMES", description: "Fine fragrances & body mists" },
  { slug: "personal-care", name: "Personal Care", description: "Skin, hair & grooming" },
  { slug: "snacks", name: "Snacks", description: "Chips, nuts & munchies" },
  { slug: "sweets-chocolates", name: "Sweets & Chocolates", description: "Traditional sweets & treats" },
  { slug: "uncategorized", name: "Uncategorized", description: "Miscellaneous items" },
];

export const getCategoryBySlug = (slug: string): Category | undefined =>
  CATEGORIES.find((c) => c.slug === slug);
